import {
  BadgeEuroIcon,
  BlocksIcon,
  BookOpenIcon,
  BuildingIcon,
  CalendarCheckIcon,
  CodeIcon,
  CuboidIcon,
  FolderKanbanIcon,
  LayoutIcon,
  SendHorizonalIcon
} from 'lucide-react';

import { baseUrl, routes } from '@workspace/routes';
import {
  LinkedInIcon,
  XIcon,
  YouTubeIcon
} from '@workspace/ui/components/brand-icons';

export const MENU_LINKS = [
  {
    title: 'CREmma',
    items: [
      {
        title: 'Bedrijven en contactpersonen',
        description: 'Het hart van je CRM, beheer al je contacten',
        icon: <BuildingIcon className="size-5 shrink-0" />,
        href: routes.marketing.features.BedrijvenEnContactpersonen,
        external: false
      },
      {
        title: 'Activiteiten en taken',
        description: 'Een gedeelde agenda en takenlijst',
        icon: <CalendarCheckIcon className="size-5 shrink-0" />,
        href: routes.marketing.features.ActiviteitenEnTaken,
        external: false
      },
      {
        title: 'Sales pipeline',
        description:
          'Een snel overzicht van alle leads en kansen? Je beheert ze met Emma.',
        icon: <FolderKanbanIcon className="size-5 shrink-0" />,
        href: routes.marketing.features.SalesPipeline,
        external: false
      },
      {
        title: 'Facturatie',
        description: 'Facturen maken en versturen via Emma.',
        icon: <BadgeEuroIcon className="size-5 shrink-0" />,
        href: routes.marketing.features.Facturatie,
        external: false
      },
      {
        title: 'Revenue hub',
        description: 'Direct inzicht in je verwachte omzet en betalingen',
        icon: <BlocksIcon className="size-5 shrink-0" />,
        href: routes.marketing.features.RevenueHub,
        external: false
      }
    ]
  },
  {
    title: 'Informatie',
    items: [
      {
        title: 'Contact',
        description: 'Voor als je een dringende vraag hebt',
        icon: <SendHorizonalIcon className="size-5 shrink-0" />,
        href: routes.marketing.Contact,
        external: false
      },
      {
        title: 'Roadmap',
        description: 'Bekijk welke modules er nog aankomen',
        icon: <LayoutIcon className="size-5 shrink-0" />,
        href: routes.marketing.Roadmap,
        external: true
      },
      {
        title: 'Documentatie',
        description: 'Wie leest er nou een handleiding?',
        icon: <BookOpenIcon className="size-5 shrink-0" />,
        href: routes.marketing.Docs,
        external: false
      },
      {
        title: 'API beschrijving',
        description: 'Bouw je eigen integratie met onze API',
        icon: <CodeIcon className="size-5 shrink-0" />,
        href: baseUrl.PublicApi,
        external: true
      }
    ]
  },
  {
    title: 'Prijzen',
    href: routes.marketing.Pricing,
    external: false
  },
  {
    title: 'Blog',
    href: routes.marketing.Blog,
    external: false
  },
  {
    title: 'Ons verhaal',
    href: routes.marketing.Story,
    external: false
  }
];

export const FOOTER_LINKS = [
  {
    title: 'CREmma',
    links: [
      {
        name: 'Bedrijven en contactpersonen',
        href: routes.marketing.features.BedrijvenEnContactpersonen,
        external: false
      },
      {
        name: 'Activiteiten en taken',
        href: routes.marketing.features.ActiviteitenEnTaken,
        external: false
      },
      {
        name: 'Sales pipeline',
        href: routes.marketing.features.SalesPipeline,
        external: false
      },
      {
        name: 'Facturatie',
        href: routes.marketing.features.Facturatie,
        external: false
      },
      {
        name: 'Revenue hub',
        href: routes.marketing.features.RevenueHub,
        external: false
      }
    ]
  },
  {
    title: 'Informatie',
    links: [
      { name: 'Contact', href: routes.marketing.Contact, external: false },
      { name: 'Roadmap', href: routes.marketing.Roadmap, external: true },
      { name: 'Documentatie', href: routes.marketing.Docs, external: false },
      { name: 'API beschrijving', href: baseUrl.PublicApi, external: true }
    ]
  },
  {
    title: 'Over ons',
    links: [
      { name: 'Ons verhaal', href: routes.marketing.Story, external: false },
      { name: 'Blog', href: routes.marketing.Blog, external: false }
    ]
  },
  {
    title: 'Voorwaarden',
    links: [
      {
        name: 'Algemene voorwaarden',
        href: routes.marketing.TermsOfUse,
        external: false
      },
      {
        name: 'Privacybeleid',
        href: routes.marketing.PrivacyPolicy,
        external: false
      },
      {
        name: 'Cookiebeleid',
        href: routes.marketing.CookiePolicy,
        external: false
      }
    ]
  }
];

export const SOCIAL_LINKS = [
  {
    name: 'X (voorheen Twitter)',
    href: 'https://x.com/cremma_itsemma',
    icon: <XIcon className="size-4 shrink-0" />
  },
  {
    name: 'YouTube',
    href: 'https://www.youtube.com/channel/UC4891nG_cpjlktPObNo1pfw',
    icon: <YouTubeIcon className="size-4 shrink-0" />
  },
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/company/cremma-crm',
    icon: <LinkedInIcon className="size-4 shrink-0" />
  }
];

export const DOCS_LINKS = [
  {
    title: 'Eerste stapjes',
    icon: <CuboidIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Welkom bij CREmma',
        href: '/docs',
        items: []
      },
      {
        title: 'Je dashboard',
        href: '/docs/dashboard',
        items: []
      },
      {
        title: 'Feedback geven',
        href: '/docs/feedback-geven',
        items: []
      }
    ]
  },
  {
    title: 'Wie is Emma?',
    icon: <CuboidIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Emma als vraagbaak',
        href: '/docs/hulp-bij-taken-en-contacten',
        items: []
      },
      {
        title: 'Hulp bij je sales pipeline',
        href: '/docs/hulp-bij-je-sales-pipeline',
        items: []
      },
      {
        title: 'Hulp bij je omzet en betalingen',
        href: '/docs/hulp-bij-je-omzet-en-betalingen',
        items: []
      },
      {
        title: 'Hulp bij je offertes',
        href: '/docs/hulp-bij-offertes',
        items: []
      }
    ]
  },
  {
    title: 'Relaties beheren',
    icon: <CuboidIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Bedrijven',
        href: '/docs/bedrijven',
        items: []
      },
      {
        title: 'Personen',
        href: '/docs/personen',
        items: []
      }
    ]
  },
  {
    title: 'Sales taken',
    icon: <CuboidIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Je sales pipeline',
        href: '/docs/sales-pipeline',
        items: []
      },
      {
        title: 'Offertes',
        href: '/docs/offertes',
        items: []
      },
      {
        title: 'Facturatie',
        href: '/docs/facturatie',
        items: []
      },
      {
        title: 'De revenue hub',
        href: '/docs/revenue-hub',
        items: []
      }
    ]
  },
  {
    title: 'Werk beheren',
    icon: <CuboidIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Je activiteiten',
        href: '/docs/activiteiten',
        items: []
      },
      {
        title: 'Taken',
        href: '/docs/taken',
        items: []
      },
      {
        title: 'Notities',
        href: '/docs/notities',
        items: []
      }
    ]
  },
  {
    title: 'Beheer je gegevens',
    icon: <CuboidIcon className="size-4 shrink-0 text-muted-foreground" />,
    items: [
      {
        title: 'Beheer je account',
        href: '/docs/beheer-account',
        items: []
      },
      {
        title: 'Beheer je organisatie',
        href: '/docs/beheer-organisatie',
        items: []
      }
    ]
  }
];
